import { getType } from 'typesafe-actions';
import * as ReportAction from '../actions/AsyncTaskReportAction';

const defaultState = {
  counter: 0,
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case getType(ReportAction.updateReportCount): {
      return { ...state, counter: action.payload };
    }
    default:
      return state;
  }
};
